import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  withStyles,
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 15,
    paddingRight: 15,
    borderTop: '1px solid #EEE',
    backgroundColor: '#FAFAFA',
  },
  label: {
    color: '#AAA',
  },
  value: {
    flexGrow: 1,
    paddingLeft: 10,
  },
});

const BedsDashboardCardFooter = ({ classes, label, value, className, onInternmentRequest, buttonVisible, buttonText }) => (
  <div className={classNames(classes.root, className)}>
    <Typography className={classes.label}>{label}</Typography>
    <Typography className={classes.value}>{value}</Typography>
  {buttonVisible &&  <Button variant="contained" color="primary" onClick={onInternmentRequest}>{buttonText}</Button>}
  </div>
);

BedsDashboardCardFooter.propTypes = {
  label: PropTypes.string.isRequired,
  onInternmentRequest: PropTypes.func
};

export default withStyles(styles)(BedsDashboardCardFooter);